export default {
  name: [],
  description: [],
  owner: [],
  id: [],
  created: [],
  updated: [],
  deleted: [],
  version: [],
  members: [],
  invitees: [],
  admins: [],
  writers: [],
  config: [],
  readers: [],
  membershipRequests: [],
  state: [
    {
      rule: 'oneof',
      parameters: ['State'],
    },
  ],
  contentHouseProfileImage: [],
}
